import { isEmpty, some } from 'lodash/fp';

import { ConfigValue } from '../../../../../../config/app/types';
import logger from '../../../../logging';

type GenerateLiveFilteringApiParams = {
  asAtDateTime: string;
  dataset: ConfigValue<'sanity:dataset'>;
  endpoint?: string;
  mode: string;
  token: string | null;
};

const generateLiveFilteringApi = ({ asAtDateTime, dataset, endpoint, mode, token }: GenerateLiveFilteringApiParams) => {
  if (some(isEmpty, [asAtDateTime, dataset, endpoint, mode, token])) {
    logger.getLogger().error('Missing required values for live filtering api generation', {
      asAtDateTime,
      dataset,
      endpoint,
      isEmptyToken: isEmpty(token),
      mode,
    });
  }
  return `${endpoint}/${dataset}/${mode}/${asAtDateTime}?token=${token}`;
};

export default generateLiveFilteringApi;
